import React from 'react';
import { painPoints } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function PainPoints() {
  return <section className="w-full bg-sky px-4 py-14 md:py-20" data-id="element-225" data-mp="26ypi16xo5ksv">
      <div className="mx-auto max-w-6xl" data-id="element-226" data-mp="26y619tjr92gf">
        <SectionHeading title="Does any of this sound familiar?" intro="If you've experienced any of these situations, I created this resource with you in mind." data-id="element-227" data-mp="2bx93754fusk6" />

        <ul className="mt-10 grid gap-x-10 gap-y-8 md:grid-cols-2" data-id="element-228" data-mp="21z36d1xhocm6">
          {painPoints.map(({
          icon: Icon,
          title,
          body
        }) => <li key={title} className="flex gap-4" data-id="element-229" data-mp="1o0lkzav23c7f">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-navy text-gold" data-id="element-230" data-mp="1o1wm12x4a5uu">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-231" data-mp="3idupeo8qw7it" />
              </span>
              <div data-id="element-232" data-mp="3nco24eg7juhx">
                <h3 className="text-lg font-bold leading-snug text-navy" data-id="element-233" data-mp="3nd7m00pf4syl">{title}</h3>
                <p className="mt-1.5 text-base leading-relaxed text-muted" data-id="element-234" data-mp="1z0op4havzbbj">{body}</p>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-12 max-w-3xl rounded-3xl bg-navy p-6 text-center text-white sm:p-8" data-id="element-235" data-mp="1u0sp0t5b8419">
          <p className="text-lg leading-relaxed text-white/85" data-id="element-236" data-mp="27sgyeoo6ceej">
            You don't necessarily need another textbook filled with information that is difficult to apply in everyday
            practice.
          </p>
          <p className="mt-3 font-display text-2xl font-bold uppercase leading-tight text-gold sm:text-3xl" data-id="element-237" data-mp="1g3x0dscks403">
            You need a clearer framework for organizing that information and asking the right clinical questions.
          </p>
          <p className="mt-3 text-base text-white/80" data-id="element-238" data-mp="1k3o1opzqa2iv">That's the purpose of this blueprint.</p>
        </div>

        <CTAButton className="mt-10" label="Yes, I want more structure" subtext="Instant digital access · $27 USD" data-id="element-239" data-mp="30h4m0qwebfv9" />
      </div>
    </section>;
}